import { NativeModules, Platform } from 'react-native';

// Check the installed binary before importing expo-secure-store, which throws
// when its native module is absent. Only old mobile binaries return null to
// retain AsyncStorage; errors from an existing secure backend never downgrade.
export function createNativeCredentialStorage() {
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    const { requireOptionalNativeModule } = require('expo');
    if (!requireOptionalNativeModule('ExpoSecureStore')) return null;
  }
  let store;
  async function backend() {
    if (Platform.OS === 'macos') {
      const native = NativeModules.MacCredentialStore;
      if (!native) throw new Error('Update Gab AI to save your session securely.');
      return native;
    }
    if (!store) {
      const secure = require('expo-secure-store');
      if (!await secure.isAvailableAsync()) throw new Error('Secure session storage is unavailable.');
      const options = { keychainService: 'ai.gab.auth.v1',
        keychainAccessible: secure.WHEN_UNLOCKED_THIS_DEVICE_ONLY };
      store = {
        getItem: key => secure.getItemAsync(key, options),
        setItem: (key, value) => secure.setItemAsync(key, value, options),
        removeItem: key => secure.deleteItemAsync(key, options),
      };
    }
    return store;
  }
  return {
    getItem: async key => (await (await backend()).getItem(key)) ?? null,
    setItem: async (key, value) => (await backend()).setItem(key, value),
    removeItem: async key => (await backend()).removeItem(key),
  };
}
